import axios, { AxiosInstance } from "axios";

export default class Request {
  public customAxios: AxiosInstance;
  constructor(baseURL: string) {
    this.customAxios = axios.create({ baseURL: baseURL });
  }

  public get = async (endPoint: string) => {
    return await this.customAxios.get(endPoint);
  };

  public post = async (endPoint: string, data: any) => {
    return await this.customAxios.post(endPoint, data);
  };

  public put = async (endPoint: string, data: any) => {
    return await this.customAxios.put(endPoint, data);
  };

  public patch = async (endPoint: string, data?: any) => {
    return await this.customAxios.patch(endPoint, data);
  };

  public delete = async (endPoint: string, data?: any) => {
    return await this.customAxios.delete(endPoint, data);
  };
}
